import React from "react";
import styles from "./HowItRunsSec.module.css";
import { Container, Row, Col } from "react-bootstrap";

const HowItRunsSec = ({
  subHeading,
  heading,
  headingSpan = false,
  steps = [],
  options = [],
  bottomNote,
  padding,
  backgroundImage,
  backgroundGradient,
}) => {
  return (
    <div
      style={{
        backgroundImage: backgroundImage
          ? `url("/images/video_background.jpg")`
          : backgroundGradient && backgroundGradient,
        padding: padding && padding,
      }}
      className={styles.main}
    >
      <Container className={styles.customContainer}>
        <div className={styles.headerWrapper}>
          {subHeading && <h3 className="h2_main">{subHeading}</h3>}
          <h2 className="h1_main">
            {heading} {headingSpan && <span>{headingSpan}</span>}
          </h2>
        </div>

        {steps.length > 0 && (
          <Row className="gy-4 gx-3 justify-content-center">
            {steps.map((step, index) => (
              <div key={index} className={styles.cardCol}>
                <div className={styles.card}>
                  <div className={styles.cardTopBar}></div>
                  <div className={styles.cardContent}>
                    <span className={styles.stepNumber}>{step.number}</span>
                    <h4 className={styles.stepTitle}>{step.title}</h4>
                    <p className={styles.stepText}>{step.text}</p>
                  </div>
                </div>
              </div>
            ))}
          </Row>
        )}

        {options.length > 0 && (
          <Row className="gy-4 gx-4 mt-4">
            {options.map((opt, index) => (
              <Col key={index} lg={6} md={6} sm={12}>
                <div className={styles.optionCard}>
                  <h3 className={styles.optionTitle}>{opt.title}</h3>
                  <ul className={styles.optionList}>
                    {opt.points.map((pt, ptIdx) => (
                      <li key={ptIdx}>{pt}</li>
                    ))}
                  </ul>
                </div>
              </Col>
            ))}
          </Row>
        )}

        {bottomNote && (
          <div className={styles.bottomNoteWrapper}>
            <p className={styles.bottomNoteText}>{bottomNote}</p>
          </div>
        )}
      </Container>
    </div>
  );
};

export default HowItRunsSec;